export default __webpack_public_path__ + "private-live-chat-icon@2x.png";